import TrackHome from "@/components/TrackHome";
import { COMMERCIAL_HOME } from "@/data/track-content";
import { COMMERCIAL_SERVICES_DATA } from "@/data/commercial-services";
import { PAGE_META } from "@/lib/seo-constants";

export default function CommercialHome() {
    return (
        <TrackHome
            trackKey="commercial"
            content={COMMERCIAL_HOME}
            servicesData={COMMERCIAL_SERVICES_DATA}
            meta={PAGE_META.commercialHome}
        />
    );
}
